import CommonEN from "./translated/en/common/common.json";
import BurnModalEN from "./translated/en/components/burnModal.json";
import FilterDropdownEN from "./translated/en/components/filterDropdown.json";
import LoadingErrorMessageEN from "./translated/en/components/loadingErrorMessage.json";
import LoadingTransactionsModalEN from "./translated/en/components/loadingTransactionsModal.json";
import TableComponentEN from "./translated/en/components/table.json";
import TiersModalEN from "./translated/en/components/tiersModal.json";
import UnboughtTierEN from "./translated/en/components/unboughtTier.json";
import ValidatorStakingModalEN from "./translated/en/components/validatorStakingModal.json";
import WalletModalEN from "./translated/en/components/walletModal.json";
import AccountToolsEN from "./translated/en/pages/accountTools.json";
import AllPagesEN from "./translated/en/pages/allPages.json";
import DashboardEN from "./translated/en/pages/dashboard.json";
import DefiOnSolanaEN from "./translated/en/pages/defiOnSolana.json";
import NFTGalleryEN from "./translated/en/pages/nftGallery.json";
import ReferralsEN from "./translated/en/pages/referrals.json";
import ReferrerInviteEN from "./translated/en/pages/referrerInvite.json";
import StepStakingEN from "./translated/en/pages/stepStaking.json";
import SwapLPEN from "./translated/en/pages/swapLP.json";
import TransactionHistoryEN from "./translated/en/pages/transactionHistory.json";

export const englishSource = {
  common: CommonEN,
  components: {
    burnModal: BurnModalEN,
    table: TableComponentEN,
    filterDropdown: FilterDropdownEN,
    tiersModal: TiersModalEN,
    unboughtTier: UnboughtTierEN,
    walletModal: WalletModalEN,
    loadingErrorMessage: LoadingErrorMessageEN,
    loadingTransactionsModal: LoadingTransactionsModalEN,
    validatorStakingModal: ValidatorStakingModalEN,
  },
  pages: {
    accountTools: AccountToolsEN,
    allPages: AllPagesEN,
    dashboard: DashboardEN,
    defiOnSolana: DefiOnSolanaEN,
    nftGallery: NFTGalleryEN,
    stepStaking: StepStakingEN,
    swapLP: SwapLPEN,
    transactionHistory: TransactionHistoryEN,
    referrals: ReferralsEN,
    referrerInvite: ReferrerInviteEN,
  },
};
